import {
  Scissors,
  Sparkles,
  Heart,
  Star,
  Smile,
  Sun,
  Flower2,
  Leaf,
  Droplets,
  Flame,
  Zap,
  Wind,
  Eye,
  Hand,
  Brush,
  PaintBucket,
  Syringe,
  Pill,
  Stethoscope,
  Dumbbell,
  Bike,
  PersonStanding,
  Bath,
  ShowerHead,
  Coffee,
  Music,
  Camera,
  Laptop,
  Wrench,
  Car,
  Home,
  Building2,
  Globe,
  Clock,
  Calendar,
  Gift,
  ShoppingBag,
  Palette,
  Gem,
  Crown,
} from 'lucide-react';

export const lucideIcons = {
  Scissors,
  Sparkles,
  Heart,
  Star,
  Smile,
  Sun,
  Flower2,
  Leaf,
  Droplets,
  Flame,
  Zap,
  Wind,
  Eye,
  Hand,
  Brush,
  PaintBucket,
  Syringe,
  Pill,
  Stethoscope,
  Dumbbell,
  Bike,
  PersonStanding,
  Bath,
  ShowerHead,
  Coffee,
  Music,
  Camera,
  Laptop,
  Wrench,
  Car,
  Home,
  Building2,
  Globe,
  Clock,
  Calendar,
  Gift,
  ShoppingBag,
  Palette,
  Gem,
  Crown,
};
